/**
 * The claims of a JWT, read without checking its signature — for what the
 * client needs to know about its own token (who, until when, on whose behalf).
 * Null when the token cannot be read.
 *
 * A JWT is base64URL, not base64: `atob` alone throws on its `-` and `_`, which
 * any claim can produce (an umlaut in a user name does), so the alphabet and
 * the dropped padding are put back first, and the bytes decoded as UTF-8.
 */
export function jwtPayload(token: string): Record<string, unknown> | null {
    const encoded = token.split('.')[1];
    if (!encoded) {
        return null;
    }
    try {
        const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
        const bytes = Uint8Array.from(atob(padded), (char) =>
            char.charCodeAt(0)
        );
        const payload: unknown = JSON.parse(new TextDecoder().decode(bytes));
        return payload && typeof payload === 'object'
            ? (payload as Record<string, unknown>)
            : null;
    } catch {
        return null;
    }
}
